import { observer } from 'mobx-react';
import React from 'react';

import { UiIcon } from 'shared/uikit-new';
import { notifier } from 'shared/utilities';

import './index.scss';

export const LayoutNotifier = observer(function LayoutNotifier() {
    const { store } = notifier();

    if (!store.isOpened) {
        return;
    }
    return (
        <div className={'layout-notifier'}>
            <div className='layout-notifier__overlay' onClick={() => store.resolve(false)} />
            <div className='layout-notifier__body'>
                <div className='layout-notifier__close' onClick={() => store.resolve(false)}>
                    <UiIcon.X size={24} />
                </div>
                {store.title && <div className='layout-notifier__title'>{store.title}</div>}
                {store.description && <div className='layout-notifier__description'>{store.description}</div>}
                <div className='layout-notifier__actions'>{store.actions(store.resolve)}</div>
            </div>
        </div>
    );
});
